module.exports = __webpack_public_path__ + "static/img/protoboard_170-1.5ff98f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/protoboard_170-1.svg
// module id = /AU8
// module chunks = 0